import styled from '@src/styled-components';
import React from 'react';

interface PropType {
  visible: boolean
  title?: string;
  children?: JSX.Element;
}

export default function SideNav(props: PropType) {
  return (
    <PagesideNav style={{ width: props.visible ? '27%' : '0%'}}>
      {props.title &&
        <div className="header"> 
          <p>
            {props.title}
          </p>
        </div>}
      <div className="body">
        {props.children}
      </div>
    </PagesideNav>
  )
}

const PagesideNav = styled.div`
  height: 100%;
  position: absolute;
  z-index: 5;
  top: 0;
  right: 0;
  background: #FFFFFF;
  overflow-x: hidden;
  border: 2px solid #EEEEEE;
  /* padding: 0 46px; */

  .header{
    display: flex;
    align-items: center;
    margin-left: 20px;
    font-family: Montserrat;
    color: #354D62;
    height: 8%;
    font-weight: bold;

    
    p{
      font-size: 140%;
      text-transform: uppercase;
      margin-top: 5%;
      font-weight: 500;
    }
  }
  .footer{
      position: absolute;
      bottom: 50px;
      right: 24px;
      .ant-btn-primary {
        color: #fff;
        background-color: #335D7C;
        border-color:  #335D7C;
        border-radius: 20px;
        font-weight: bold;
        width: 116px;
        height: 36px;
      }
      .ant-btn-background-ghost {
        background: transparent !important;
        border-color: #fff;
        color: #335D7C;
        font-weight: bold;
        width: 116px;
        height: 36px;
      }
    }
`
